import { AdminMixerService } from '@linktivity/triplabo-taxfree';
import config from '../config';

const adminUserApi = new AdminMixerService.AdminUserApi(config);
const agentApi = new AdminMixerService.AgentApi(config);
const csApi = new AdminMixerService.CSApi(config);
const dashboardApi = new AdminMixerService.DashboardApi(config);
const groupApi = new AdminMixerService.GroupApi(config);
const masterApi = new AdminMixerService.AccountApi(config);
const merchantApi = new AdminMixerService.MerchantApi(config);
const orderApi = new AdminMixerService.OrderApi(config);
const regiApi = new AdminMixerService.RegiApi(config);

export {
  adminUserApi,
  agentApi,
  csApi,
  dashboardApi,
  groupApi,
  masterApi,
  merchantApi,
  orderApi,
  regiApi
};
